export const fromProductSlugtoUrl = (slug) =>`/products/${slug}`